import { render, staticRenderFns } from "./EsqueciMinhaSenha.vue?vue&type=template&id=aa4717a2"
import script from "./EsqueciMinhaSenha.vue?vue&type=script&lang=ts"
export * from "./EsqueciMinhaSenha.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports